import "./styled.scss";

// TODO: change this function to use functional component syntax
export const ToastContent = (message: string, idMessage?: string) => {
  return (
    <div>
      {message}
      {idMessage && <p>{idMessage}</p>}
    </div>
  );
};
